// 회원관리 필드명 리스트
export const MemberAttributes = Object({
    branchSeq: '',
    createDate: '',
    eMail: '이메일',
    instituteSeq: '소속학원',
    lastUpdateDate: '',
    mobilephone: '핸드폰 번호',
    name: '이름',
    password: '비밀번호',
    passwordChk: '비밀번호',
    photo: '',
    status: '상태',
    telephone: '전화번호',
    userID: 'ID',
    userType: '멤버 타입',
    zipCode: '우편번호',
    zipDetail: '주소세부',
    zipName: '주소' 
})